module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_F.66e0ceb9.mp3";